var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('header',{staticClass:"main-header"},[_c('CommonHeader')],1),_c('main',{staticClass:"main-content",attrs:{"role":"main"}},[_c('router-view')],1),_c('footer',{staticClass:"main-footer"},[_c('CommonFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }